import {ReaderDevice} from "./readerDevice";


export class ReaderDeviceGroup {

  public type: string;

  public deviceList: Array<ReaderDevice>;

  fromDevice(device: ReaderDevice): ReaderDeviceGroup {
    this.type = device.type;
    this.deviceList = [];
    this.deviceList.push(device);
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/models/reader-model/readerDeviceGroup.ts